"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pullAll = void 0;
const pull_1 = require("./pull");
exports.pullAll = (iterable, iteratees) => pull_1.pull(iterable, ...iteratees);
//# sourceMappingURL=pull-all.js.map